import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Package, MapPin, ChevronRight } from 'lucide-react';

const RecentBatches = ({ batches }) => {
  const navigate = useNavigate();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-NO', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const getStatusColor = (status) => {
    const statusMap = {
      'Delivered': 'bg-emerald-50 text-emerald-800 border-emerald-300',
      'In Transit': 'bg-slate-100 text-slate-700 border-slate-300',
      'Processing': 'bg-amber-50 text-amber-700 border-amber-300',
      'In Storage': 'bg-slate-100 text-slate-700 border-slate-300',
    };
    return statusMap[status] || 'bg-slate-50 text-slate-700 border-slate-200';
  };

  return (
    <div className="bg-white rounded-xl border border-slate-200" data-testid="recent-batches">
      <div className="divide-y divide-slate-100">
        {batches.map((batch) => (
          <div
            key={batch.id}
            data-testid={`recent-batch-${batch.id}`}
            onClick={() => navigate(`/batches/${batch.id}`)}
            className="p-6 hover:bg-slate-50 transition-colors cursor-pointer group"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-start gap-4 flex-1">
                <div className="p-3 bg-slate-100 rounded-lg group-hover:bg-slate-200 transition-colors">
                  <Package className="w-5 h-5 text-slate-700" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-lg font-semibold text-slate-800 group-hover:text-slate-900 transition-colors">
                      {batch.product_name}
                    </h3>
                    <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getStatusColor(batch.current_status)}`}>
                      {batch.current_status}
                    </span>
                  </div>
                  <p className="text-sm text-slate-500 mb-2">{batch.batch_number} • {batch.species}</p>
                  <div className="flex items-center gap-4 text-sm text-slate-600">
                    <div className="flex items-center gap-1">
                      <MapPin className="w-4 h-4" />
                      <span>{batch.origin.name}</span>
                    </div>
                    <span>•</span>
                    <span>{formatDate(batch.catch_date)}</span>
                    <span>•</span>
                    <span>{batch.weight_kg.toLocaleString()} kg</span>
                  </div>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-slate-700 group-hover:translate-x-1 transition-all" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentBatches;
